module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av454-370bcf69f3269813b52dc5f444fb7c0d.jpg";